import { render } from "./TagsInput.vue?vue&type=template&id=c093ee30"
import script from "./TagsInput.vue?vue&type=script&lang=js"
export * from "./TagsInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__